import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import { auth  } from '../firebase/firebase-config'



const logInWithEmailAndPassword = (email: any, password: any) => signInWithEmailAndPassword(auth, email, password);
  
const sendPasswordReset = async (email: any) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err: any) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  return signOut(auth);
};

export {
  logInWithEmailAndPassword,
  sendPasswordReset,
  logout,
};
